import { Rewards } from './rewards';

export type ReferralCode = string;

export enum RedeemCodeResponseState {
  INVALID = 'INVALID',
  SIGNED_UP = 'SIGNED_UP',
  LINKED_BANK = 'LINKED_BANK',
  REWARD_ISSUED = 'REWARD_ISSUED',
}

export type RedeemCodeResponse = {
  success: boolean;
  state: RedeemCodeResponseState;
};

export type ReferralStatus = {
  email?: string;
  state: string;
  referrerVoucherUuid?: string;
  nudgable: boolean;
  updatedAt: string;
  referee: ReferralUser;
  referrer: ReferralUser;
  voucherAmount?: string;
  voucherState?: Rewards.VoucherState;
};

export type ReferralUser = {
  firstName: string;
  lastInitial: string;
};
